import type { TokenApiDAO } from "@/domains/tokens/types"
import { LcAddress } from "@/domains/core"
import { TokenStore } from "@/domains/tokens/token-store"

export class MinimalPoolApiFactory {
  static createToken(tokenData: {
    address: LcAddress
    symbol: string
    decimals: number
    priceUsd: number
  }): TokenStore {
    const tokenDAO: TokenApiDAO = {
      address: tokenData.address,
      symbol: tokenData.symbol,
      name: tokenData.symbol,
      decimals: tokenData.decimals,
      priceUsd: tokenData.priceUsd.toString(), // Default price
      isWhitelisted: false,
      isSwapToken: false,
      isIncentiveToken: false,
      tags: [],
    }

    return new TokenStore(tokenDAO, "system", "minimal-pools")
  }
}
